import React, { Component } from "react";
import style from "../login/login.module.css";
import * as routes from "../shared/routes";
import analytics from "../shared/analytics"

class RecoverConfirmation extends Component {
  constructor(props) {
    super(props);
    analytics.pageView();
    this.buttonRef = React.createRef();
  }

  componentDidMount() {
    this.buttonRef.current.addEventListener('click', () => {
      this.props.history.push(routes.login);
    }
    )
  }

  render() {
    let logoUrl = "https://cdn.svc.oneadvanced.com/mosaic/2.0.0/img/logo.svg";
    let logoAlt = "Advanced"
    if (process.env.NODE_ENV === 'production') {
      logoUrl = window.applicationIcon;
      logoAlt = window.applicationName;
    }
    return (
      <React.Fragment>
        <mosaic-page class={style.mosaicpage}>
          <mosaic-content-container>
            <mosaic-main-container fluid>
              <div className={style.pageBgOverlay} />
              <mosaic-card class={style.card}>
                <mosaic-card-body class="pb-0">
                  <div className={style.logo}>
                    <img
                      src={logoUrl}
                      alt={logoAlt}
                    />
                  </div>
                  <h1 className={style.appName}>
                    <span><mosaic-translation Key="app.company.name"></mosaic-translation></span>
                  </h1>
                  <h2 className={style.contentTitle}>Instructions sent</h2>
                  <p className={style.strapLine}>If an account exists with the email you entered, we have emailed you instructions for setting your password. They should arrive shortly.</p>

                  <p className={style.strapLine}>If you do not receive an email, please make sure you have entered the address you registered with and check your spam folder.</p>

                  <mosaic-button color="primary" icon="back" class="btn-block" ref={this.buttonRef} block>Back to the login page</mosaic-button>
                </mosaic-card-body>
                <mosaic-card-footer class="p-0">
                  <div className={style.loginFooter}>
                    <small className={style.small}>&copy;2019 Advanced</small>
                  </div>
                </mosaic-card-footer>
              </mosaic-card>
            </mosaic-main-container>
          </mosaic-content-container>
        </mosaic-page>
      </React.Fragment>
    );
  }
}

export default RecoverConfirmation;

